// Query-cache helpers keep report actions responsive by patching cached rows in
// place instead of forcing every action to wait for a full refetch to update the UI.
const getStableRowId = (row) => row?.id || row?.rowId || row?.__rowId || null;

export const patchReportQueryRow = ({ queryClient, reportId, row, patch }) => {
  if (!queryClient || !reportId || !row || !patch) return false;
  const rowId = getStableRowId(row);
  if (!rowId) return false;

  let didPatch = false;
  // Patch any cached page/params variant of this report's query, not just the currently-visible one.
  queryClient.setQueriesData({ queryKey: ['reportQuery', reportId] }, (current) => {
    if (!current || !Array.isArray(current.rows)) return current;

    let changed = false;
    const nextRows = current.rows.map((entry) => {
      const entryId = getStableRowId(entry);
      if (entryId !== rowId) return entry;
      changed = true;
      return { ...entry, ...patch };
    });

    if (!changed) return current;
    didPatch = true;
    return { ...current, rows: nextRows };
  });

  return didPatch;
};
